module.exports = __webpack_public_path__ + "img/icon-other-asset.0815f76b.svg";